import React from 'react';
import { Column as ColumnEntity } from 'new/elements/Table/types';
import styles from 'new/elements/Table/Table.module.scss';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { useTableContext } from 'new/elements/Table/useTableContext';
import { IconButton } from '@mui/material';

export function SortIconButton<T>({ column }: { column: ColumnEntity<T> }) {
  const { sortDirection, sortField, onClickSort } = useTableContext<T>();
  const isCurrentSortField = sortField === column.field;

  if (!column.sortable) return null;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClickSort(column.field);
  };

  const getIcon = () => {
    if (!isCurrentSortField || sortDirection === 'none') {
      return <ArrowDownward fontSize="small" />;
    }
    if (sortDirection === 'asc') {
      return <ArrowUpward fontSize="small" />;
    }
    return <ArrowDownward fontSize="small" />;
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      className={styles.sortIconButton}
      aria-label="sort column"
    >
      {getIcon()}
    </IconButton>
  );
}
